import { MainLayout } from "components/layouts";
import PolicyForm from "./PolicyForm";
import { useTranslation } from "react-i18next";
import { Breadcrumb, Flex, Space } from "antd";

const PolicyCreate = (props) => {
  props = { ...props, isCreate: true };
  const { t } = useTranslation();

  return (
    <MainLayout>
      <Space direction="vertical" size={24} style={{ width: "100%" }}>
        <Flex vertical>
          <Breadcrumb items={[
            { title: t("home.header"), href: "/" },
            { title: t("news_policy.header"), href: "/news_policy/policy" },
            { title: t("policy_list.header"), href: "/news_policy/policy" },
            { title: t("common.create") }
          ]}
          />
          <h2>{t("common.create")}</h2>
        </Flex>
        <PolicyForm {...props} />
      </Space>
    </MainLayout>
  );
};

export default PolicyCreate;
